import { GF_FieldError, GF_Email } from '../../../model/gforms/gform';
import useGravityForm, {
  ACTION_TYPES,
  EmailFieldValue,
  FieldValue,
} from '../../../hooks/GFormsHooks';
import { FieldDescription } from './subparts/FieldDescription';
import { FieldDecorator } from './subparts/FieldDecorator';

interface Props {
  field: GF_Email;
  fieldErrors: GF_FieldError[];
}

const DEFAULT_VALUE = '';

export default function EmailField({ field, fieldErrors }: Props) {
  const {
    id,
    formId,
    type,
    label,
    description,
    cssClass,
    isRequired,
    placeholder,
    visibility,
  } = field;
  const htmlId = `field_${formId}_${id}`;
  const { state, dispatch } = useGravityForm();
  const fieldValue = state.find(
    (fieldValue: FieldValue) => fieldValue.id === id
  ) as EmailFieldValue | undefined;
  const value = fieldValue?.emailValues?.value || DEFAULT_VALUE;

  return (
    <div
      className={`relative border border-primary px-5 pt-3 rounded-2xl mt-4 md:mt-5 gfield gfield-${type} ${cssClass} ${
        visibility === 'hidden' ? 'hidden' : ''
      }`.trim()}
    >
      <label
        className="text-sm text-black font-medium top-3 left-4 md:top-5 md:left-6"
        htmlFor={htmlId}
      >
        {label}
      </label>
      <FieldDecorator>
        <input
          className="w-full border-0 text-black text-sm italic pl-0 focus:ring-0 focus:ring-offset-0 focus:outline-none focus:border-primary"
          type="email"
          name={String(id)}
          id={htmlId}
          placeholder={placeholder || ''}
          required={Boolean(isRequired)}
          value={value}
          onChange={(event) => {
            dispatch({
              type: ACTION_TYPES.updateEmailFieldValue,
              fieldValue: {
                id,
                emailValues: {
                  value: event.target.value,
                },
              },
            });
          }}
        />
      </FieldDecorator>
      <FieldDescription description={description} />
      {fieldErrors?.length
        ? fieldErrors.map((fieldError) => (
            <p
              key={fieldError.id}
              className="error-message text-error font-medium text-sm mt-2"
            >
              {fieldError.message}
            </p>
          ))
        : null}
    </div>
  );
}
